import React, { Component } from 'react';
import { Redirect }         from "react-router-dom";
import Navbar               from './Navbar';
import { isAuthenticated }  from './Login'
import API                  from './server_api'


export default class NewProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:           '',
            description:    '',
            processing:     false,  // уже отправили запрос на сервер
            processed:      false,  // уже получили ответ сервере
            id:             '',     // id нового проекта
        };

        this.handleInputChange     = this.handleInputChange.bind(this);
        this.onCreate              = this.onCreate.bind(this);
        this.onCreated             = this.onCreated.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({ [target.id]: target.value });
    }

    onCreate(event){
        API.addProject(this.onCreated, this.state.name, this.state.description );
        this.setState({ processing: true });
        event.preventDefault();
    }

    onCreated(json) {
        this.setState({ processed: true, id: json.id });
    }

    render() {
        // неавторизованных пользователей перенаправляем на страницу логина
        if ( !isAuthenticated() )
            return (<Redirect to={{ pathname: "/login", state: { from: this.props.location }}} />);

        // после получения ответа от сервера отправляем на сраницу настроек нового проекта
        if ( this.state.processed )
            return (<Redirect to={ '/project/'+this.state.id } />);

        return ([
            <Navbar key='navbar' />,
            <main key='body' role="main" className="container">
                <form onSubmit={this.onCreate} autoComplete="off">
                    <fieldset disabled={this.state.processing}>
                        <h2 className='mt-3'>Создать новый проект</h2>
                        <div className="form-group">
                            <input type="text" 
                                className="form-control"
                                id="name" 
                                placeholder="Введите название" 
                                onChange={this.handleInputChange}
                                value={this.state.name}
                                required />
                        </div>
                        <div className="form-group">
                            <textarea className="form-control"
                                id="description" 
                                rows="3" 
                                placeholder="Описание проекта (не обязательно)" 
                                onChange={this.handleInputChange}
                                value={this.state.description} />
                        </div>
                        <button type="submit" className="btn btn-primary">Создать</button>
                    </fieldset>
                </form>
            </main>
        ]);
    }
}
